module.exports = __webpack_public_path__ + "img/cloud_app.38285fc0.jpg";